module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
for (var i = 0; i < data.length; i++) {
    var _uuid = Math.floor((Math.random() * 1000000) + 1);
    var obj = data[i];
    var title = '';
    if(obj.title){
        title = obj.title;
    }else if(obj.alt){
        title = obj.alt;
    }

    var phatomTitle = title;

    if(obj.dataTracking){
        var splittedTracking = obj.dataTracking.split('|');
        phatomTitle = splittedTracking[0];
    }

    var id;
    if(obj.id){
        id = obj.id
    }else{
        id = obj.contentId
    }

    var contentType = 'show';

    if(obj.contentType){
        contentType = obj.contentType;
    }

    if(obj.isMovie){
        contentType = 'movie';
    }
    
    var impressionContentType = contentType;
    if(obj.isOnNow){
        impressionContentType = obj.streamType;
    }

    if (obj.isSports && obj.isCollectionCarousel) {
        obj.startDateISOClass = 'meta-airdate-left';
        obj.metaSeasonNumberClass = 'hide';
        obj.metaEpisodeNumberClass = 'hide';
    } else {
        obj.startDateISOClass = '';
        obj.metaSeasonNumberClass = '';
        obj.metaEpisodeNumberClass = '';
    }

    if (obj.locked || obj.bundleLocked) {
        if(obj.orientation == 'portrait'){
            obj.lockIconClass = 'bundle-lock portrait';
        }else{
            obj.lockIconClass = 'bundle-lock';
        }
        
        obj.lockGradientClass = 'bundle-lock-gradient';
    }

    var cmsId = '';
    if(obj.cmsId) {
        cmsId = obj.cmsId;
    }

    ; __append("\n\n\n    ")
    ;  if(data[i]) { 
    ; __append("\n\n    <!-- ABTest: homepage descriptions :: contentId used by growth team -->\n    <a class=\"link ")
    ; __append(escapeFn( (data[i].status === 'PREMIUM' && !data[i].isUserSubscriber)?'subscribe':'' ))
    ; __append("\"\n\n        ")
    ;  if(id) { 
    ; __append("\n            id=\"")
    ; __append(escapeFn( id ))
    ; __append("\"\n        ")
    ;  } 
    ; __append("\n\n        ")
    ;  if(data[i].genre) { 
    ; __append("\n            data-genre=\"")
    ; __append(escapeFn( data[i].genre ))
    ; __append("\"\n        ")
    ;  } 
    ; __append("\n\n        ")
    ;  if(data[i].showGenre) { 
    ; __append("\n            data-genre=\"")
    ; __append(escapeFn( data[i].showGenre ))
    ; __append("\"\n        ")
    ;  } 
    ; __append("\n\n        ")
    ;  if(data[i].href !== '') { 
    ; __append("\n            href=\"")
    ; __append(escapeFn( data[i].href ))
    ; __append("\"\n        ")
    ;  } 
    ; __append("\n\n        ")
    ;  if(data[i].actionTarget !== '') { 
    ; __append("\n            target=\"")
    ; __append(escapeFn( data[i].actionTarget ))
    ; __append("\"\n        ")
    ;  } 
    ; __append("\n\n        ")
    ;  if(title !== '') { 
    ; __append("\n            title=\"")
    ; __append(escapeFn( title ))
    ; __append("\"\n        ")
    ;  } 
    ; __append("\n\n        ")
    ;  if(data[i].aaLink !== '') { 
    ; __append("\n            aa-link=\"")
    ; __append(escapeFn( data[i].aaLink ))
    ; __append("\"\n        ")
    ;  } 
    ; __append("\n\n        ")
    ;  if(data[i].dataTracking) { 
    ; __append("\n            data-tracking=\"")
    ; __append(escapeFn( data[i].dataTracking ))
    ; __append("\"\n        ")
    ;  } 
    ; __append("\n\n        ")
    ;  if(data[i].content_id) { 
    ; __append("\n            vilynx-id=\"")
    ; __append(escapeFn(data[i].content_id))
    ; __append("\"\n        ")
    ;  } 
    ; __append("\n\n        ")
    ;  if (typeof data[i].contentId !== 'undefined') { 
    ; __append("\n                ")
    ;  if(data[i].contentId) { 
    ; __append("\n                    vilynx-id=\"")
    ; __append(escapeFn(data[i].contentId))
    ; __append("\"\n                ")
    ;  } 
    ; __append("\n        ")
    ;  } 
    ; __append("\n\n        ")
    ;  if (data[i].promoTile) { 
    ; __append("\n\n            data-fathom = '")
    ; __append(escapeFn(data[i].hubId))
    ; __append("||0|promo_")
    ; __append(escapeFn(data[i].contentType))
    ; __append("||")
    ; __append(escapeFn(data[i].title))
    ; __append("||'\n            data-impression = '")
    ; __append(escapeFn(data[i].hubId))
    ; __append("||0|promo_")
    ; __append(escapeFn(data[i].contentType))
    ; __append("||")
    ; __append(escapeFn(data[i].title))
    ; __append("|||||'\n\n        ")
    ;  } else { 
    ; __append("\n\n            data-fathom = '")
    ; __append(escapeFn(data[i].contentIdFathom))
    ; __append("|getdisplayIDAbove|")
    ; __append(escapeFn(data[i].position))
    ; __append("|")
    ; __append(escapeFn(contentType))
    ; __append("|")
    ; __append(escapeFn(data[i].recoId))
    ; __append("|")
    ; __append(escapeFn(phatomTitle))
    ; __append("|")
    ; __append(escapeFn(data[i].rankModel))
    ; __append("|")
    ; __append(escapeFn(data[i].pvrModel))
    ; __append("'\n            data-impression = '")
    ; __append(escapeFn(data[i].contentIdFathom))
    ; __append("|getdisplayIDAbove|")
    ; __append(escapeFn(data[i].position))
    ; __append("|")
    ; __append(escapeFn(impressionContentType))
    ; __append("|")
    ; __append(escapeFn(data[i].recoId))
    ; __append("|")
    ; __append(escapeFn(phatomTitle))
    ; __append("|")
    ; __append(escapeFn(data[i].rankModel))
    ; __append("|")
    ; __append(escapeFn(data[i].pvrModel))
    ; __append("|")
    ; __append(escapeFn(data[i].badgeLabel))
    ; __append("|")
    ; __append(escapeFn(data[i].bundleLocked))
    ; __append("|")
    ; __append(escapeFn(cmsId))
    ; __append("'\n\n        ")
    ;  } 
    ; __append("\n\n    >\n\n<div class=\"thumb-wrapper ")
    ;  if(data[i].slug) { 
    ; __append(escapeFn( data[i].slug ))
    ;  } 
    ; __append(" ")
    ;  if(data[i].onNowTitle) { 
    ; __append("always-on")
    ;  } 
    ; __append("\">\n\n    <!-- START ABTest: homepage descriptions -->\n    ")
    ;  if(hasHomePageDescriptionVariant) { 
    ; __append("\n        <div class=\"homepage-description-wrapper\"\n            ")
    ;  if(data[i].contentIdFathom) { 
    ; __append("\n                show-id=\"")
    ; __append(escapeFn(data[i].contentIdFathom))
    ; __append("\"\n            ")
    ;  } 
    ; __append("\n            >\n            <div class=\"homepage-description-show-wrapper\">\n                ")
    ;  if(data[i].seasonNumber && data[i].episodeNumber) { 
    ; __append("\n                    S")
    ; __append(escapeFn( data[i].seasonNumber ))
    ; __append("\n                ")
    ;  } 
    ; __append("\n\n                ")
    ;  if(data[i].episodeNumber) { 
    ; __append("\n                    E")
    ; __append(escapeFn( data[i].episodeNumber ))
    ; __append("\n                ")
    ;  } 
    ; __append("\n\n                ")
    ;  if( data[i].episodeNumber && data[i].seasonNumber ) { 
    ; __append("\n                    <span>")
    ; __append(escapeFn( data[i].seriesTitle || data[i].title ))
    ; __append("</span>\n                ")
    ;  } else if(data[i].alt) { 
    ; __append("\n                    ")
    ; __append(escapeFn( data[i].alt ))
    ; __append("\n                ")
    ;  } 
    ; __append("\n\n            </div>\n            ")
    ; __append("\n            ")
    ;  if(data[i].about){ 
    ; __append("\n            <div class=\"homepage-description-about-wrapper\">\n                ")
    ; __append(escapeFn( data[i].about ))
    ; __append("\n            </div>\n            ")
    ;  } 
    ; __append("\n\n            <div class=\"bottom-description-wrapper\">\n                ")
    ;  if(data[i].numSeasons || data[i].movieDuration || data[i].movieRating || data[i].startDate || data[i].rating) { 
    ; __append("\n                <div class=\"bottom-left-description-wrapper\">\n                    ")
    ;  if(data[i].numSeasons) { 
    ; __append("\n                        <span>\n                            ")
    ; __append(escapeFn( data[i].numSeasons ))
    ; __append(" SEASON")
    ;  if(data[i].numSeasons > 1){ 
    ; __append("S")
    ;  } 
    ; __append("\n                        </span>\n                    ")
    ;  } 
    ; __append("\n                    ")
    ;  if(data[i].movieDuration) { 
    ; __append("\n                        <span>\n                            ")
    ; __append(escapeFn( data[i].movieDuration ))
    ; __append("\n                        </span>\n                    ")
    ;  } 
    ; __append("\n                    ")
    ;  if(data[i].movieRating) { 
    ; __append("\n                        <span>\n                            ")
    ; __append(escapeFn( data[i].movieRating ))
    ; __append("\n                        </span>\n                    ")
    ;  } 
    ; __append("\n                    ")
    ;  if(data[i].startDate) { 
    ; __append("\n                        <span>\n                            ")
    ; __append(escapeFn( data[i].startDate ))
    ; __append("\n                        </span>\n                    ")
    ;  } 
    ; __append("\n                    ")
    ;  if(data[i].rating) { 
    ; __append("\n                        <span>\n                            ")
    ; __append(escapeFn( data[i].rating ))
    ; __append("\n                        </span>\n                    ")
    ;  } 
    ; __append("\n                    ")
    ;  if(data[i].genre) { 
    ; __append("\n                        <span>\n                            ")
    ; __append(escapeFn( data[i].genre ))
    ; __append("\n                        </span>\n                    ")
    ;  } 
    ; __append("\n                </div>\n                ")
    ;  } 
    ; __append("\n                <div class=\"bottom-right-description-wrapper\">\n                    ")
    ;  if(data[i].status === 'PREMIUM' && !data[i].isUserSubscriber) { 
    ; __append("\n                    <div class=\"label subscribe\">Subscribe</div>\n                    ")
    ;  } else if(data[i].poster) { 
    ; __append("\n                    <div class=\"label document circle-sm\"></div>\n                    ")
    ;  } else { 
    ; __append("\n                    <div class=\"label play circle-sm\"></div>\n                    ")
    ;  } 
    ; __append("\n                </div>\n            </div>\n        </div>\n    ")
    ;  } 
    ; __append("\n    <!-- END ABTest: homepage descriptions -->\n\n            ")
    ;  if (data[i].scheduleBadge) { 
    ; __append("\n            <div class=\"schedule-badge\">\n                ")
    ;  if (data[i].isListingLive) { 
    ; __append("\n                    <span class=\"live-badge\"></span>\n                    <span class=\"badge-copy\">")
    ; __append(escapeFn( data[i].liveBadgeText || 'LIVE' ))
    ; __append("</span>\n                ")
    ;  } else { 
    ; __append("\n                    <span class=\"badge-copy\">")
    ; __append(escapeFn( data[i].scheduleBadgeText ))
    ; __append("</span>\n                ")
    ;  } 
    ; __append("\n            </div>\n            ")
    ;  } 
    ; __append("\n\n\n            <!-- Promo Tile -->\n            ")
    ;  if (data[i].promoTile) { 
    ; __append("\n            <div class=\"promoInfo\">\n                ")
    ;  if (data[i].ctaLine1) { 
    ; __append("\n                    <div class=\"promoIcon\"> \n                        <img  src=\"")
    ; __append(escapeFn( data[i].promoIcon ))
    ; __append("\" > \n                    </div>\n                    <div class=\"promoType\">\n                        HUB\n                    </div>\n                ")
    ;  } 
    ; __append("\n                ")
    ;  if (data[i].ctaLine1) { 
    ; __append("\n                    <div class=\"promoCTALine1\">")
    ; __append(escapeFn( data[i].ctaLine1 ))
    ; __append("</div>\n                ")
    ;  } 
    ; __append("\n                ")
    ;  if (data[i].ctaLine2) { 
    ; __append("\n                    <div class=\"promoCTALine2\">")
    ; __append(escapeFn( data[i].ctaLine2 ))
    ; __append("</div>\n                ")
    ;  } 
    ; __append("\n            </div>\n            ")
    ;  } 
    ; __append("\n\n\n\n            ")
    ;  if (typeof editable !== 'undefined') { 
    ; __append("\n            <label class=\"edit-container\">\n                <input  type=\"checkbox\"\n                        name=\"editor\"\n                ")
    ;  if(data[i].showId) { 
    ; __append("\n                    value=\"")
    ; __append(escapeFn( data[i].showId ))
    ; __append("/")
    ; __append(escapeFn(data[i].showSeriesId))
    ; __append("|")
    ; __append(escapeFn(data[i].showSeriesTitle))
    ; __append("|")
    ; __append(escapeFn(data[i].showGenre))
    ; __append("|")
    ; __append(escapeFn(data[i].showDayPart))
    ; __append("|")
    ; __append(escapeFn(data[i].showEpisodeId))
    ; __append("|")
    ; __append(escapeFn(data[i].showEpisodeLabel))
    ; __append("|")
    ; __append(escapeFn(data[i].showSeasonNumber))
    ; __append("|")
    ; __append(escapeFn(data[i].showEpisodeNumber))
    ; __append("|")
    ; __append(escapeFn(data[i].showAirDate))
    ; __append("|")
    ; __append(escapeFn(data[i].contentId))
    ; __append("\"\n                ")
    ;  } 
    ; __append("                >\n                <span class=\"checkmark\"  ></span>\n                <div class=\"overlay\" ></div>\n            </label>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if(!data[i].characterImage) { 
    ; __append("\n                ")
    ;  if(data[i].channelFallbackThumb) { 
    ; __append("\n                <!-- Thumbnail fallback -->\n                <input class=\"hidden-fallback-img\" type=\"hidden\" value=\"")
    ; __append(escapeFn( data[i].channelFallbackThumb ))
    ; __append("\"></input>\n                ")
    ;  } 
    ; __append("\n                <img class=\"thumb lazy\"\n                ")
    ;  if(data[i].thumb) { 
    ; __append("\n                    data-src=\"")
    ; __append(escapeFn( data[i].thumb ))
    ; __append("\"\n                ")
    ;  } 
    ; __append("\n                ")
    ;  if(data[i].alt) { 
    ; __append("\n                    alt=\"")
    ; __append(escapeFn( data[i].alt ))
    ; __append("\"\n                ")
    ;  } 
    ; __append("\n                >\n            ")
    ;  } 
    ; __append("\n\n            <!-- START ABTest: homepage descriptions -->\n            ")
    ;  if(data[i].poster && hasHomePageDescriptionVariant) { 
    ; __append("\n                <img class=\"thumb poster\"\n                     data-src=\"")
    ; __append(escapeFn( data[i].poster ))
    ; __append("\"\n                ")
    ;  if(data[i].alt) { 
    ; __append("\n                    alt=\"")
    ; __append(escapeFn( data[i].alt ))
    ; __append("\"\n                ")
    ;  } 
    ; __append("\n                >\n            ")
    ;  } 
    ; __append("\n            <!-- END ABTest: homepage descriptions -->\n\n            ")
    ; __append("\n            ")
    ;  if(data[i].progress && data[i].progress > 0) { 
    ; __append("\n                ")
    ; 
                    var progress = data[i].progress;
                
    ; __append("\n                ")
    ; (function(){
    ; __append("\n")
    ; __append("\n")
    ; __append("\n")
    ; __append("\n\n<style>\n\n    #progress-bar-")
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.25);\n    }\n\n    #progress-bar-")
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #0037C5, #0064FF);\n        background-image: linear-gradient(135deg, #0037C5, #0064FF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        animation: slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        ")
    ; __append("\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-")
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;}\n\n        to {\n            width: ")
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @keyframes slideProgress-")
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-")
    ; __append(escapeFn( _uuid ))
    ; __append("\" data-percentage=\"")
    ; __append(escapeFn( progress ))
    ; __append("\">\n    <div class=\"bar")
    ;  if (typeof hasRendered !== 'undefined' && hasRendered) { 
    ; __append(" hasRendered ")
    ;  } 
    ; __append("\"></div>\n</div>\n")
    ; }).call(this)
    ; __append("\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if(false) { 
    ; __append("\n            <video id=\"")
    ; __append(escapeFn( data[i].brandId ))
    ; __append("\" class=\"brand-bkgd\" autoplay playsinline muted>\n                <source src=\"")
    ; __append(escapeFn( data[i].animatedBackground ))
    ; __append("\" type=\"video/mp4\">\n                Sorry, your browser doesn't support embedded videos.\n            </video>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if(data[i].characterImage) { 
    ; __append("\n                <img class=\"thumb lazy character-img\" data-src=\"")
    ; __append(escapeFn( data[i].characterImage ))
    ; __append("\" src=\"")
    ; __append(escapeFn( data[i].characterImage ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( data[i].title ))
    ; __append("\">\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if(data[i].background) { 
    ; __append("\n            <img class=\"brand-bkgd-static\" src=\"")
    ; __append(escapeFn( data[i].background ))
    ; __append("\" onerror='this.src=\"")
    ; __append(escapeFn( data[i].fallbackBackground ))
    ; __append("\"'>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if(data[i].brandLogo) { 
    ; __append("\n            <div class=\"brandLogo ")
    ; __append(escapeFn( data[i].slug ))
    ; __append("\">\n                <img data-src=\"")
    ; __append(escapeFn( data[i].brandLogo ))
    ; __append("\" src=\"")
    ; __append(escapeFn( data[i].brandLogo ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( data[i].title ))
    ; __append("\">\n            </div>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if(data[i].isUserSubscriber && data[i].bundleLocked) { 
    ; __append("\n            <div class=\"")
    ; __append(escapeFn( data[i].lockGradientClass ))
    ; __append("\"></div>\n            ")
    ;  } 
    ; __append("\n\n            ")
    ;  if (data[i].isUserSubscriber && (data[i].locked || data[i].bundleLocked)||data[i].subscriptionLevel === 'TVE_PAID') { 
    ; __append("\n                ")
    ;  if (!data[i].onNowTitle) { 
    ; __append("\n                <div class=\"label ")
    ; __append(escapeFn( data[i].lockIconClass ))
    ; __append("\"><img src=\"")
    ; __append(escapeFn( data[i].lockIcon ))
    ; __append("\"/></div>\n                ")
    ;  } 
    ; __append("\n            ")
    ;  } else if(data[i].icon) { 
    ; __append("\n            <div class=\"label ")
    ; __append(escapeFn( data[i].icon ))
    ; __append(" circle-sm\"></div>\n            ")
    ;  } else if(data[i].status === 'PREMIUM' && !data[i].isUserSubscriber) { 
    ; __append("\n            <div class=\"subscribe-gradient\"></div>\n            <div class=\"label subscribe\">Subscribe</div>\n            ")
    ;  } else if(data[i].status === 'AVAILABLE') { 
    ; __append("\n            <div class=\"play label circle-sm\">\n                ")
    ;  if(data[i].content_id) { 
    ; __append("\n                <svg class=\"svg-loader\" viewbox=\"0 0 33.83098862 33.83098862\" width=\"30\" height=\"30\"\n                    xmlns=\"http://www.w3.org/2000/svg\">\n                    <circle class=\"svg-loader__circle\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-dasharray=\"100\" fill=\"none\"\n                        cx=\"16.91549431\" cy=\"16.91549431\" r=\"15.91549431\"/>\n                </svg>\n                ")
    ;  } 
    ; __append("\n            </div>\n            ")
    ;  } 
    ; __append("\n\n    ")
    ;  if(data[i].onNowTitle) { 
    ; __append("\n    <div class=\"onnow-wrapper\">\n        <div class=\"onnow-wrapper-inside\">\n            <div class=\"channel-logo\">\n                ")
    ;  if (data[i].channelLogo) { 
    ; __append("\n                    <img src=\"")
    ; __append(escapeFn( data[i].channelLogo ))
    ; __append("\">\n                ")
    ;  } 
    ; __append("\n            </div>\n            ")
    ;  if ( ((data[i].locked || data[i].bundleLocked) && data[i].isUserSubscriber) || (data[i].isLocal && data[i].lockIcon && !data[i].isUserSubscriber) ) { 
    ; __append("\n            <div class=\"")
    ; __append(escapeFn( data[i].lockGradientClass ))
    ; __append("\"></div>\n            <div class=\"label ")
    ; __append(escapeFn( data[i].lockIconClass ))
    ; __append("\">\n                <img src=\"")
    ; __append(escapeFn( data[i].lockIcon ))
    ; __append("\"/>\n            </div>\n            ")
    ;  } 
    ; __append("\n        </div>\n    </div>\n    ")
    ;  } 
    ; __append("\n\n    ")
    ;  if (data[i].ratingIcon){ 
    ; __append("\n    <img class=\"ratings-icon lazy\"\n         src=\"")
    ; __append(escapeFn( data[i].ratingIcon ))
    ; __append("\"\n         alt=\"")
    ; __append(escapeFn( data[i].ratingText ))
    ; __append("\" />\n    ")
    ;  } 
    ; __append("\n            ")
    ;  if (data[i].badgeLabel){ 
    ; __append("\n              <div class=\"new-item-container\">\n                <div class=\"new-item\">")
    ; __append(escapeFn( data[i].badgeLabel ))
    ; __append("</div>\n              </div>\n            ")
    ;  } 
    ; __append("\n    </div>\n\n    <div class=\"info-wrapper\">\n        ")
    ;  if(data[i].onNowTitle) { 
    ; __append("\n        <div class=\"info-onnow-wrapper\">\n            <div class=\"runTime noDescription\">\n                <span class=\"season-string\">")
    ; __append(escapeFn( data[i].seasonString ))
    ; __append("</span>\n                ")
    ;  if(data[i].duration){ 
    ; __append("\n                    <span class=\"meta-gray\">\n                        ")
    ; __append(escapeFn( data[i].duration ))
    ; __append("\n                    </span>\n                ")
    ;  } else { 
    ; __append("\n                    <span class=\"time-details\">\n                        ")
    ;  if(data[i].onNowTimeElapsed) { 
    ; __append("\n                            ")
    ; __append(escapeFn( data[i].onNowTimeElapsed ))
    ; __append("\n                        ")
    ;  } else { 
    ; __append("\n                            ")
    ; __append(escapeFn( data[i].onNowrunTime ))
    ; __append(" ")
    ; __append(escapeFn(data[i].onNowTimeRemaining ))
    ; __append("\n                        ")
    ;  } 
    ; __append("\n                    </span>\n                ")
    ;  } 
    ; __append("\n            </div>\n            <div class=\"title-wrapper\">\n                <div class=\"on-title\" data-title=\"")
    ; __append(escapeFn( data[i].onNowTitle ))
    ; __append("\">\n                    ")
    ; __append(escapeFn( data[i].onNowTitle ))
    ; __append("\n                </div>\n            </div>\n        </div>\n        ")
    ;  } 
    ; __append("\n\n        \n        ")
    ; __append("\n        ")
    ;  if(!data[i].isMovie && data[i].seasonNumber && data[i].episodeNumber) { 
    ; __append("\n            <span class=\"meta-white ")
    ; __append(escapeFn( data[i].metaSeasonNumberClass ))
    ; __append("\">\n                <abbr aria-label=\"Season ")
    ; __append(escapeFn( data[i].seasonNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('season') ))
    ; __append(" ")
    ; __append(escapeFn( data[i].seasonNumber ))
    ; __append("\">\n                    ")
    ; __append(escapeFn( getLocale('season_number_abbr', {'seasonNumber': data[i].seasonNumber }) ))
    ; __append("\n                </abbr>\n            </span>\n            <span class=\"meta-white ")
    ; __append(escapeFn( data[i].metaEpisodeNumberClass ))
    ; __append("\">\n                <abbr aria-label=\"Episode ")
    ; __append(escapeFn( data[i].episodeNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('episode') ))
    ; __append(" ")
    ; __append(escapeFn( data[i].episodeNumber ))
    ; __append("\">\n                    ")
    ; __append(escapeFn( getLocale('episode_number_abbr', {'episodeNum': data[i].episodeNumber }) ))
    ; __append("\n                </abbr>\n            </span>\n            <span class=\"meta-gray meta-airdate ")
    ; __append(escapeFn( data[i].startDateISOClass ))
    ; __append("\">\n                <time datetime=\"")
    ; __append(escapeFn( data[i].startDateISO ))
    ; __append("\">\n                     ")
    ; __append(escapeFn( data[i].startDate ))
    ; __append("\n                </time>\n            </span>\n        ")
    ;  } 
    ; __append("\n\n\n        ")
    ; __append("\n        ")
    ;  if(data[i].isNewsTopStories && data[i].startDate) { 
    ; __append("\n        <span class=\"meta-gray meta-airdate\">\n                <time datetime=\"")
    ; __append(escapeFn( data[i].startDateISO ))
    ; __append("\">\n                     ")
    ; __append(escapeFn( data[i].startDate ))
    ; __append("\n                </time>\n            </span>\n        ")
    ;  } 
    ; __append("\n\n        ")
    ; __append("\n        ")
    ;  if(data[i].winner) { 
    ; __append("\n            <span class=\"nom-winner\">\n                <img class=\"thumb lazy\" data-src=\"")
    ; __append(escapeFn( data[i].winner_icon ))
    ; __append("\" alt=\"Winner\" title=\"Winner\" />\n            </span>\n        ")
    ;  } 
    ; __append("\n\n        ")
    ; __append("\n        ")
    ;  if(!data[i].isMovie && data[i].duration && !data[i].onNowTitle && data[i].displayItemTitle){ 
    ; __append("\n            <span class=\"meta-gray\">\n                ")
    ; __append(escapeFn( data[i].duration ))
    ; __append("\n            </span>\n        ")
    ;  } 
    ; __append("\n\n        ")
    ; __append("\n        ")
    ;  if(data[i].characterName){ 
    ; __append("\n            <span class=\"meta-gray\">\n                ")
    ; __append(escapeFn( data[i].characterName ))
    ; __append("\n            </span>\n        ")
    ;  } 
    ; __append("\n\n        ")
    ; __append("\n        ")
    ;  if(data[i].startTime){ 
    ; __append("\n        <div class=\"startTime-wrapper\">\n            <div class=\"startTime\">\n                ")
    ; __append(escapeFn( data[i].startTime ))
    ; __append("\n            </div>\n            ")
    ;  if(i == 0){ 
    ; __append("\n            <div class=\"liveNow\"><div class=\"blue-dot blinking\"></div> LIVE</div>\n            ")
    ;  } 
    ; __append("\n        </div>\n        ")
    ;  } 
    ; __append("\n\n\n        ")
    ; __append("\n        ")
    ;  if((data[i].rating ||data[i].yearMin) && contentType==='movie'  ){ 
    ; __append("\n        <span class=\"meta-gray\">\n            ")
    ;  if(data[i].yearMin){ 
    ; __append("\n                ")
    ; __append(escapeFn( data[i].yearMin ))
    ; __append("\n             ")
    ;  } 
    ; __append("\n            ")
    ;  if(data[i].rating){ 
    ; __append("\n                ")
    ; __append(escapeFn( data[i].rating ))
    ; __append("\n             ")
    ;  } 
    ; __append("\n        </span>\n        ")
    ;  } 
    ; __append("\n\n\n        ")
    ; __append("\n        ")
    ;  if(data[i].title && !data[i].onNowTitle && data[i].displayItemTitle ){ 
    ; __append("\n            <div class=\"title-wrapper\">\n                <div class=\"title\" data-title=\"")
    ; __append(escapeFn( data[i].title ))
    ; __append("\">\n                    ")
    ; __append(escapeFn( data[i].title ))
    ; __append("\n                </div>\n            </div>\n        ")
    ;  } 
    ; __append("\n\n        ")
    ; __append("\n        ")
    ;  if(data[i].description){ 
    ; __append("\n        <div class=\"description-wrapper\" id=\"js-schedule-description\">\n            <div class=\"description\" id=\"js-schedule-copy\">\n                ")
    ; __append(escapeFn( data[i].description ))
    ; __append("\n            </div>\n            <div class=\"runTime\">\n                ")
    ; __append(escapeFn( data[i].runTime ))
    ; __append("\n            </div>\n        </div>\n        ")
    ;  } else { 
    ; __append("\n            <div class=\"runTime noDescription\">\n                ")
    ; __append(escapeFn( data[i].runTime ))
    ; __append("\n            </div>\n        ")
    ;  } 
    ; __append("\n\n        ")
    ; __append("\n        ")
    ;  if(data[i].appearanceDate){ 
    ; __append("\n            <div class=\"guests-appearance-date\">\n                ")
    ; __append(escapeFn( data[i].appearanceDate ))
    ; __append("\n            </div>\n        ")
    ;  } 
    ; __append("\n\n        ")
    ; __append("\n        ")
    ;  if(data[i].guests_array){ 
    ; __append("\n        <div class=\"guests\" id=\"guests\">\n        </div>\n        ")
    ; 
            var div = document.getElementById('guests');
            for(var guest in data[i].guests_array) {
                div.innerHTML += '<div class="guest">'+guest+'</div>';
            }
        
    ; __append("\n\n        ")
    ;  } 
    ; __append("\n\n    </div>\n\n    </a>\n\n    <div class=\"break\"></div>\n\n\n    ")
    ;  } 
    ; __append("\n\n")
    ;   } 
    ; __append("\n")
  }
  return __output;

}